import { default as AkFlag, type FlagProps as AkFlagProps } from '@atlaskit/flag';

import type {
	ChoreographedComponentProps,
	ChoreographerMessageTypes,
	ChoreographerUtilities,
} from '../../types';
import { wrapComponentForChoreographer } from '../utils';

export const Flag: {
	({
		shouldBeChoreographed,
		withChoreographedRender,
		...props
	}: AkFlagProps &
		ChoreographerUtilities &
		Partial<ChoreographedComponentProps> & {
			messageType?: ChoreographerMessageTypes;
		}): React.JSX.Element;
	displayName: string;
} = wrapComponentForChoreographer<AkFlagProps>(AkFlag);
